import { FormHelperText, styled } from '@mui/material';

const HelperTextContainer = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.error.main,
}));

export default HelperTextContainer;
